import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'; // import icons
import MenuItemCard from '../MenuPage/custom-comp/MenuItemCard'; // adjust path as needed
import './BitDetailedViewCard.css'; // optional

const CollapsibleMenuSection = ({ title = 'Breakfast', items = [] , image, isveg}) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className='bdvc-menu'>
      <div
        className='menu-catogory'
        onClick={() => setIsOpen((prev) => !prev)}
        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
      >
        <span>{title}</span>
        {isOpen ? <FiChevronUp size={18} /> : <FiChevronDown size={18} />}
      </div>

      {isOpen && (
        <div className='menu-items'>
          {items.map((item, index) => (
            <MenuItemCard
              key={index}
              item={item}
              image={image}
              disabled={true}
              onToggle={() => {}}
              hideCheckbox={true}
              isveg={isveg}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CollapsibleMenuSection;
